import { Modal, Progress, Upload } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { PictureOutlined } from "@ant-design/icons";
import { deleteFeaturedImage, sendFeaturedImage } from "../../service/api";
import { useMutation } from "@tanstack/react-query";
import ImgCrop from "antd-img-crop";
import { toast } from "react-toastify";

export default function WordpressUploader({
  type,
  setFeaturedImageKey,
  setInEditorImageKey,
  postData,
  setPostData,
  setOpenUploader
}) {
  const Types = {
    FeaturedImage: "featuredImage",
    InlineImage: "inlineImage",
  };
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const sendFeaturedImageMutation = useMutation(sendFeaturedImage);
  const deleteFeaturedImageMutation = useMutation(deleteFeaturedImage);

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file);
    }

    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name);
  };

  const customRequest = async (options) => {
    const { file, onSuccess, onError, onProgress } = options;
    const isLt5M = (file.size / (1024 * 1024)) * 10 <= 5;
    if (!isLt5M) {
      onError(toast.error("حجم فایل باید کمتر از   5 مگابایت باشد"));
      return;
    }
    if (type === Types.InlineImage) {
      try {
        // send file name to get upload info
        const response = await axios.post(
          process.env.REACT_APP_EXPERT_BASE_URL + "/files/s3-upload-file",
          { filename: file?.name }
        );
        // destructure upload info
        const { url, fields } = response?.data?.result?.data;
        const { key } = fields; // key is in fields
        setInEditorImageKey(key);
        // create formdata
        let formData = new FormData();
        Object.entries(fields).map(([key, value]) => {
          return formData.append(key, value);
        });
        formData.append("file", file);

        // progress tracking config
        const config = {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Update the upload progress
            onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
          },
        };

        // upload formdata to Arvan cloud
        const arvanResponse = await axios.post(url, formData, config);
        // add originFileObj and key to file
        file.originFileObj = file;
        file.key = key;

        setFileList([...fileList, file]);
        // call onSuccess
        onSuccess(arvanResponse?.data);
      } catch (error) {
        onError(error);
      }
    } else {
      if (postData?.featuredMediaId || postData?.featured_media) {
        //  first delete previous from wp repository
        deleteFeaturedImageMutation.mutate(postData?.featuredMediaId || postData?.featured_media, {
          onSuccess: () => {
            const config = {
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setUploadProgress(percentCompleted); // Update the upload progress
                onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
              },
            };
            sendFeaturedImageMutation.mutate(
              { file, config },
              {
                onSuccess: ({ data }) => {
                  file.originFileObj = file;
                  setFileList([...fileList, file]);
                  setFeaturedImageKey(data?.source_url);
                  setPostData((prev) => ({ ...prev, featured_media: data?.id }));
                  setOpenUploader(false)
                },
              }
            );
          },
        });
      } else {
        const config = {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Update the upload progress
            onProgress({ percent: percentCompleted }, file); // Notify Ant Design of the progress
          },
        };
        sendFeaturedImageMutation.mutate(
          { file, config },
          {
            onSuccess: ({ data }) => {
              file.originFileObj = file;
              setFileList([...fileList, file]);
              setFeaturedImageKey(data?.source_url);
              setPostData((prev) => ({ ...prev, featured_media: data?.id }));
            },
          }
        );
      }
    }
  };

  const onRemove = (file) => {
    if (type === Types.FeaturedImage) {
      deleteFeaturedImageMutation.mutate(postData.featured_media, {
        onSuccess: () => {
          setFileList([]);
          setFeaturedImageKey("");
          return new Promise((resolve, reject) => {
            resolve(true);
          });
        },
      });
    }
  };

  return (
    <>
      {type === Types.FeaturedImage ? (
        <ImgCrop
          modalTitle="برش تصویر"
          modalOk="تایید"
          modalCancel="لغو"
          resetText="لغو تغییرات"
          showGrid
          aspect={1.58}
          showReset
        >
          <Upload
            listType="picture-card"
            fileList={fileList}
            onPreview={handlePreview}
            onRemove={onRemove}
            customRequest={customRequest}
            accept=".png, .jpg, .jpeg"
            maxCount={1}
          >
            {fileList.length > 0 ? null : (
              <div>
                <PictureOutlined className="text-6xl text-[#7F7F7F]" />
                <p className="text-center font-body text-xs">انتخاب</p>
              </div>
            )}
          </Upload>
        </ImgCrop>
      ) : (
        <Upload
          listType="picture-card"
          fileList={fileList}
          onPreview={handlePreview}
          customRequest={customRequest}
          accept=".png, .jpg, .jpeg"
          maxCount={1}
        >
          {fileList.length > 0 ? null : (
            <div>
              <PictureOutlined className="text-6xl text-[#7F7F7F]" />
              <p className="text-center font-body text-xs">انتخاب</p>
            </div>
          )}
        </Upload>
      )}
      {uploadProgress > 0 && uploadProgress < 100 && (
        <Progress
          className="z-50 lg:w-1/4 m-auto translate-x-3 max-lg:w-1/3 max-lg:mr-3"
          percent={uploadProgress}
          status="active"
          type="line"
          showInfo={false}
        />
      )}
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={() => setPreviewOpen(false)}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
      
    </>

  );
}
